// The search pop-up lives in the shell (layouts/DashboardLayout), which owns its state.
// A page that wants to offer search, such as the bar on the home screen, asks for it
// with this event instead of reaching into the shell.
export const OPEN_SEARCH_EVENT = 'cp:open-search';

export const openSearch = (): void => {
  window.dispatchEvent(new Event(OPEN_SEARCH_EVENT));
};

/** What search says it finds: the words in the pop-up's box and on the home screen's bar. One wording, both places. */
export const SEARCH_PROMPT = 'Search people, stores, pages…';
